type Market = {
    id: string | number;
    name: string;
};

export const getUniqueMarketId = (market: Market): string => {
    const { id, name } = market;

    return `${name} ${id}`;
};
